module.exports = __webpack_public_path__ + "resources/img/img_spiceware_pii_anp_01_en.a927e9a7633edeac4bd39dc531f0bfa5.png";